/** @format */

import React, { useRef, useState } from "react";
// import TabBar from "@/src/components/TabBar/TabBar";
import { TabBar } from "@themed-components";
import styles from "../Stats.module.css";
import { useStats } from "../../../hooks/data/useStats";
import {
  DURATION_DROPDOWN_ITEMS,
  GAME_VARIANT_TABS,
  STATS_CORNER_TABS,
} from "@/src/constants/StatsCornerConstants";
import TournamentStats from "./pages/TournamentStats";
import AbbreviationsDrawer from "../components/AbbreviationsDrawer";
import { CashGamesStats } from "./pages/CashGamesStats";
import { Button } from "@/src/components/ui/button";
import { CustomDropdownButton } from "@/src/components/DropdownButton/DropdownButton";
import { StatsWelcome } from "../components/StatsWelcome";
import { StatsHeader } from "../components/StatsHeader";
import { StatsLoader } from "../components/StatsLoader";
import { useDisplayName } from "@/src/hooks/data/useLobby";

export default function A23Stats() {
  const [activeTab, setActiveTab] = useState(STATS_CORNER_TABS[0]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeGameVariant, setActiveGameVariant] = useState(
    GAME_VARIANT_TABS[0].id
  );
  const [durationSelected, setDurationSelected] = useState(
    DURATION_DROPDOWN_ITEMS[DURATION_DROPDOWN_ITEMS.length - 1].id
  );
  const gameVariantRefs = useRef([]);

  const durationSelectedObj = DURATION_DROPDOWN_ITEMS.find(
    (item) => item.id === durationSelected
  );

  const { statsData, isLoading, isError, error } = useStats({
    gameType: activeTab.gameType,
    gameVariant: activeGameVariant,
    durationSelectedObj,
  });

  const onGameTabChange = (tab) => {
    setActiveTab(tab);
  };

  const onInfoClick = () => {
    setIsDrawerOpen(true);
  };

  const displayName = useDisplayName();

  const onVariantTabChange = (itemId, index) => {
    if (gameVariantRefs.current[index]) {
      gameVariantRefs.current[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
    setActiveGameVariant(itemId);
  };

  return (
    <div className="h-screen bg-background flex flex-col overflow-hidden relative">
      <div className="non-scroll-area flex flex-col bg-header-bg fixed top-0 left-0 right-0 z-10">
        <StatsHeader onInfoClick={onInfoClick} />
      </div>
      <div
        className={`scroll-area ${styles.noScrollbar} overflow-y-auto scroll-smooth absolute top-14 left-0 right-0 bottom-0`}
      >
        <StatsWelcome userName={displayName} joinTime="25 july 2025" />
        <div className="free-scroll-section relative z-1">
          <div className="sticky-scroll-section sticky top-0 z-9">
            <div>
              <TabBar
                tabs={STATS_CORNER_TABS}
                activeTab={activeTab}
                onTabChange={onGameTabChange}
                showSort={false}
              />
            </div>
            <div className="tab-section grid grid-cols-3 sticky top-0 z-9 bg-background pb-4">
              <div
                className={`${styles.noScrollbar} overflow-x-scroll col-span-2 mt-[18px] flex justify-start gap-[8px] ml-4`}
              >
                {GAME_VARIANT_TABS.map((item, i) => {
                  return (
                    <Button
                      key={item.id}
                      ref={(el) => (gameVariantRefs.current[i] = el)}
                      variant={
                        item.id === activeGameVariant ? "solid" : "outline"
                      }
                      className={`${
                        item.id === activeGameVariant
                          ? "bg-accent text-primary border-accent"
                          : "text-secondary border-b-dark"
                      } ${
                        i === GAME_VARIANT_TABS.length - 1 ? "mr-3" : ""
                      } text-xs px-[12px] py-[6px] focus:outline-none`}
                      onClick={() => onVariantTabChange(item.id, i)}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </div>
              <div
                className={`${styles.fadeLeft} relative duration-section flex mt-[18px] px-2.5`}
              >
                <CustomDropdownButton
                  dropdownItems={DURATION_DROPDOWN_ITEMS}
                  selectedDropdownId={durationSelected}
                  setSelectedDropdownId={setDurationSelected}
                />
              </div>
            </div>
          </div>
          <div className="px-4 mb-5.75">
            {(() => {
              let content;
              if (isLoading) {
                content = <StatsLoader type={activeTab} />;
              } else {
                content =
                  activeTab.gameType === "CASH" ? (
                    <CashGamesStats pageData={statsData} />
                  ) : (
                    <TournamentStats statsData={statsData} />
                  );
              }
              return content;
            })()}
          </div>
        </div>
        <AbbreviationsDrawer
          isOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
        />
      </div>
    </div>
  );
}
